export const getTimestamp = () => new Date().getTime();

export const daysToMilliseconds = (days: number) => days * 24 * 60 * 60 * 1000;
